module.exports = __webpack_public_path__ + "img/showDescription.1a1292b6.png";